import Man from "../../assets/manu.png";
import Forum from "../../assets/forum.png";
import Liver from "../../assets/liver.png";
import Transfer from "../../assets/transfer.png";

export const ForumsData = [
  {
    name: "Real Madrid",
    members: "53 Members",
    bgColor: "#ea014f",
    image: Man
  },
  {
    name: "Rugby",
    members: "53 Connections",
    bgColor: "#4c5162",
    image: Forum
  },
  {
    name: "Jane Cooper",
    members: "53 Connections",
    bgColor: "#74ada4",
    image: Liver
  },
  {
    name: "Esther Howard",
    members: "53 Connections",
    bgColor: "#115a77",
    image: Transfer
  },
  {
    name: "Brooklyn Simmons",
    members: "53 Connections",
    bgColor: "#ea014f",
    image: Man
  },
  {
    name: "Guy Hawkins",
    members: "53 Connections",
    bgColor: "#4c5162",
    image: Forum
  },
  {
    name: "Bessie Cooper",
    members: "53 Connections",
    bgColor: "#74ada4",
    image: Liver
  },
  {
    name: "Savannah Nguyen",
    members: "53 Connections",
    bgColor: "#115a77",
    image: Transfer
  },
  {
    name: "Eleanor Pena",
    members: "53 Connections",
    bgColor: "#ea014f",
    image: Man
  },
  {
    name: "Floyd Miles",
    members: "53 Connections",
    bgColor: "#4c5162",
    image: Transfer
  },
  {
    name: "Dianne Russell",
    members: "53 Connections",
    bgColor: "#74ada4",
    image: Liver
  },
  {
    name: "Courtney Henry",
    members: "53 Connections",
    bgColor: "#4c5162",
    image: Man
  }
];